import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';
import { DestinationModel } from '../../models/simple-types/destination.model';
import { DestinationDTO } from '../../dtos/destinationDTO';
import { NTHDestination, orderDestinations } from '../../constants/flag';
import { CategorieModel } from '../../models/simple-types/categorie.model';

@Injectable()
export class DestinationService extends GenericLibelleService<DestinationModel> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEDESTINATION, hostnameService);
  }

  getDestinationDTOFromActivite(idActivite: number): Observable<DestinationDTO[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<DestinationDTO[]>(APICONSTANTS.URLAPI.value + this.route + 'getDestinationDTOFromActivite?idActivite=' + idActivite)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
  
  updateDestinations(objet: DestinationDTO[]): Observable<DestinationDTO[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.post<DestinationDTO[]>(APICONSTANTS.URLAPI.value + this.route + 'updateDestinations/', objet)
      .pipe(catchError(err => this.requestCatchError(err, 'Mise à jour des destinations')));
  }

  getDestinationsFromActiviteAndCa1(idSociete: number, codeCa1: string): Observable<NTHDestination[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<NTHDestination[]>(APICONSTANTS.URLAPI.value + this.route + 'getDestinationsFromActiviteAndCa1?idSociete=' + idSociete  + '&codeCa1=' + codeCa1)
      .pipe(map(dest => orderDestinations(dest)), catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getCategoriesForDestination(idSociete: number, codeCa1: string,  destination: NTHDestination): Observable<CategorieModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<CategorieModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getCategoriesForDestination?idSociete=' + idSociete  + '&codeCa1=' + codeCa1 + '&destination=' + destination)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getCategoriesForDestinationEnveloppe(idSociete: number, codeCa1: string,  destination: NTHDestination): Observable<CategorieModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<CategorieModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getCategoriesForDestinationEnveloppe?idSociete=' + idSociete  + '&codeCa1=' + codeCa1 + '&destination=' + destination)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
